// src/theme/tokens/highlight.js
// Faz 1 · Annotation/highlight pencil renkleri.
// reader-annotations.css icindeki hardcoded rgba() degerleri buradan
// CSS variable olarak okunur (var(--chakra-colors-highlightYellow) ...).
// Light/dark variant ayni opaklik ailesinde tutulur; karanlik modda saturation/alpha
// sayfa arka planinda kontrasti korumak icin hafifce dusurulur.

const highlightTokens = {
  highlightYellow: { default: 'rgba(250, 204, 21, 0.42)', _dark: 'rgba(250, 204, 21, 0.32)' },
  highlightGreen:  { default: 'rgba(74, 222, 128, 0.38)', _dark: 'rgba(74, 222, 128, 0.28)' },
  highlightBlue:   { default: 'rgba(96, 165, 250, 0.36)', _dark: 'rgba(96, 165, 250, 0.30)' },
  highlightPink:   { default: 'rgba(244, 114, 182, 0.38)', _dark: 'rgba(244, 114, 182, 0.30)' },
  highlightPurple: { default: 'rgba(167, 139, 250, 0.42)', _dark: 'rgba(167, 139, 250, 0.30)' },

  highlightYellowBorder: { default: 'rgba(161, 98, 7, 0.55)',  _dark: 'rgba(161, 98, 7, 0.55)' },
  highlightGreenBorder:  { default: 'rgba(22, 101, 52, 0.55)', _dark: 'rgba(22, 101, 52, 0.55)' },
  highlightBlueBorder:   { default: 'rgba(30, 64, 175, 0.55)', _dark: 'rgba(30, 64, 175, 0.55)' },
  highlightPinkBorder:   { default: 'rgba(157, 23, 77, 0.55)', _dark: 'rgba(157, 23, 77, 0.55)' },
  highlightPurpleBorder: { default: 'rgba(91, 33, 182, 0.55)', _dark: 'rgba(91, 33, 182, 0.55)' },

  highlightYellowChip: { default: 'rgba(250, 204, 21, 0.8)', _dark: 'rgba(250, 204, 21, 0.8)' },
  highlightGreenChip:  { default: 'rgba(74, 222, 128, 0.8)', _dark: 'rgba(74, 222, 128, 0.8)' },
  highlightBlueChip:   { default: 'rgba(96, 165, 250, 0.8)', _dark: 'rgba(96, 165, 250, 0.8)' },
  highlightPinkChip:   { default: 'rgba(244, 114, 182, 0.8)', _dark: 'rgba(244, 114, 182, 0.8)' },
  highlightPurpleChip: { default: 'rgba(167, 139, 250, 0.8)', _dark: 'rgba(167, 139, 250, 0.8)' },
};

export default highlightTokens;
export { highlightTokens };
